import AmigoHeader from './AmigoHeader';

export default AmigoHeader;
